var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgEventImg1(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 92,
    height: 100,
    viewBox: "0 0 92 100",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Frame 2526"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M21.3633 97.8182C27.1501 97.8182 31.8412 95.2799 31.8412 92.1488C31.8412 89.0177 27.1501 86.4795 21.3633 86.4795C15.5765 86.4795 10.8854 89.0177 10.8854 92.1488C10.8854 95.2799 15.5765 97.8182 21.3633 97.8182Z",
    fill: "#FFFFF1"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M65.7163 100C76.7365 100 85.6702 95.1662 85.6702 89.2032C85.6702 83.2402 76.7365 78.4062 65.7163 78.4062C54.696 78.4062 45.7623 83.2402 45.7623 89.2032C45.7623 95.1662 54.696 100 65.7163 100Z",
    fill: "#FFFFF1"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M29.3256 66.2736V72.1804V80.4173L29.1104 95.9634C27.1959 97.0988 24.4354 97.8186 21.3633 97.8186C20.5841 97.8186 19.8198 97.7741 19.0852 97.685L19.2558 93.8115C19.4488 89.4852 17.9721 88.5799 17.3636 88.4315C13.7349 87.5707 11.019 84.2908 11.019 80.4173V72.1804H17.5862C17.6975 73.8946 19.1297 75.2525 20.8735 75.2525C22.6174 75.2525 24.0496 73.8946 24.1609 72.1804H24.1683V67.0454L15.1745 58.0516C14.1727 57.0498 14.1727 55.4099 15.1745 54.4081C16.1763 53.4063 17.8163 53.4063 18.818 54.4081L28.2867 63.8768C28.7542 64.2255 29.0956 64.7227 29.244 65.3015C29.333 65.6132 29.3627 65.9471 29.3256 66.2736Z",
    fill: "#FF9571"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_4",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M36.0932 82.8805L37.5254 81.4483L38.9576 80.0161L14.0985 55.1571L9.96527 53.8882L11.2342 58.0215L36.0932 82.8805Z",
    fill: "#FFF3D2"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_5",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17.5788 63.7653V75.0668C17.5788 76.87 16.1021 78.3467 14.2989 78.3467C12.4957 78.3467 11.019 76.87 11.019 75.0668V63.7653C11.019 61.9621 12.4957 60.4854 14.2989 60.4854C16.1021 60.4854 17.5788 61.9621 17.5788 63.7653Z",
    fill: "#FF9571"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_6",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M82.9395 10.1143H41.1021L27.6337 47.0911H32.2271C41.8442 47.0911 40.4936 52.2187 40.4936 62.5259V69.4494C40.4936 78.406 39.9297 79.6156 45.881 79.6156C49.1535 79.6156 49.0496 82.2054 49.0496 83.3185V95.1543C52.0401 97.6105 56.8264 99.3618 62.3992 99.8664H69.0333C74.9623 99.3321 80.0083 97.3805 82.9395 94.672V10.1143Z",
    fill: "#FF9571"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_7",
    d: "M45.458 28.3542C49.212 28.3542 52.2552 27.7363 52.2552 26.974C52.2552 26.2117 49.212 25.5938 45.458 25.5938C41.7039 25.5938 38.6607 26.2117 38.6607 26.974C38.6607 27.7363 41.7039 28.3542 45.458 28.3542Z",
    fill: "#FFFFF1"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_8",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M46.6453 25.616C46.7937 25.8386 46.8828 26.0983 46.8828 26.3878C46.8828 27.1595 46.2446 27.7902 45.4506 27.7902C44.664 27.7902 44.0184 27.1669 44.0184 26.3878C44.0184 26.1058 44.1075 25.8386 44.2559 25.616C44.6418 25.6012 45.0425 25.5938 45.4506 25.5938C45.8662 25.5937 46.2595 25.6012 46.6453 25.616Z",
    fill: "#2A0317"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_9",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M42.2597 62.2217H43.6177C44.3375 62.2217 44.9311 62.8153 44.9311 63.5351C44.9311 64.2549 44.3375 64.8486 43.6177 64.8486H42.2597C41.5399 64.8486 40.9463 64.2549 40.9463 63.5351C40.9463 62.8153 41.5325 62.2217 42.2597 62.2217Z",
    fill: "#2A0317"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_10",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M56.0324 10.1143H41.1021L40.9686 10.4853C41.1763 4.6824 45.9849 0 51.8323 0H81.1214C86.8427 0 91.5696 4.48204 91.9704 10.1143H92V10.8786V21.7498V66.444H72.8549V46.3268C72.8549 45.2211 72.9514 42.6239 69.6863 42.6239C63.735 42.6239 64.2989 41.4144 64.2989 32.4577V25.5343C64.2989 15.2419 65.6495 10.1143 56.0324 10.1143Z",
    fill: "#FFF3D2"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_11",
    d: "M31.2921 34.3575C31.2921 33.274 31.7299 32.302 32.4348 31.5896C33.1398 30.8846 34.1193 30.4468 35.2027 30.4468C36.2861 30.4468 37.2582 30.8846 37.9706 31.5896C38.2155 31.8345 38.4232 32.109 38.6013 32.4058C39.0392 31.3966 39.6625 30.4913 40.4342 29.727C42.0148 28.1464 44.1965 27.1743 46.6007 27.1743C49.005 27.1743 51.1867 28.1538 52.7673 29.727C54.3479 31.3076 55.32 33.4892 55.32 35.8935C55.32 38.2978 54.3404 40.4795 52.7673 42.06C51.1867 43.6406 49.005 44.6127 46.6007 44.6127C44.1965 44.6127 42.0148 43.6332 40.4342 42.06C38.8536 40.4795 37.8815 38.2978 37.8815 35.8935C37.8815 35.2924 37.9409 34.7136 38.0596 34.1423C38.0077 33.4373 37.7035 32.8066 37.236 32.3316C36.7239 31.8122 36.0041 31.5005 35.2176 31.5005C34.431 31.5005 33.7186 31.8196 33.1991 32.3316C32.6871 32.8437 32.368 33.5635 32.368 34.35H31.2921V34.3575ZM39.1134 34.2313C39.1134 34.2684 39.1134 34.3129 39.1134 34.35H39.0837C38.9798 34.8472 38.9279 35.3592 38.9279 35.8935C38.9279 38.0084 39.7886 39.9229 41.1689 41.3106C42.5565 42.6982 44.471 43.5516 46.5859 43.5516C48.7008 43.5516 50.6153 42.6908 52.0029 41.3106C53.3906 39.9229 54.244 38.0084 54.244 35.8935C54.244 33.7786 53.3832 31.8641 52.0029 30.4765C50.6153 29.0888 48.7008 28.2355 46.5859 28.2355C44.471 28.2355 42.5565 29.0963 41.1689 30.4765C40.1671 31.4931 39.4325 32.7843 39.1134 34.2313Z",
    fill: "#2A0317"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_12",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M35.2621 47.1655H53.0567L50.1404 59.1498H32.3384L35.2621 47.1655Z",
    fill: "#FFF3D2"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEventImg1);
export default __webpack_public_path__ + "static/media/event-img1.bca102d2c64a756f1c461d12d7160198.svg";
export { ForwardRef as ReactComponent };